/**
 * @ngdoc Directive
 * @name vrm-red-banner
 * @example
 *
 * <vrm-red-banner installation="installation" />
 *
 */

(function () {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmRedBanner', vrmRedBanner);

    /* @ngInject */
    function vrmRedBanner($rootScope) {

        var definition = {
            restrict: 'E',
            template: require('@/angular/modules/vrm-components/red-banner/red-banner.template.html'),
            link: link,
            transclude: true,
            scope: {
                installation: '=',
            },
        };

        return definition;

        function link($scope) {
            $scope.bannerDismissed = false;

            $scope.closeBanner = function () {
                $scope.bannerDismissed = true;
            }

            $scope.hasWarning = function () {
                if (!$scope.installation) return false;

                let hasWarning = false;
                let hasError = false;
                _.each($scope.installation.current_alarms_formatted, function(alarm) {
                    hasWarning = hasWarning || alarm.indexOf("Warning") > 0;
                    hasError = hasError || alarm.indexOf("Warning") <= 0;
                });
                return hasWarning && !hasError;
            }
        }
    }
})();
